import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

import state from './state.js'
import mutations from './mutations.js'
import getters from './getters.js'

import actions from './actions.js'
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [createPersistedState()],
})



// WEBPACK FOOTER //
// ./src/store/index.js